const Book = props => (
  <svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M11 5.5c-2.2-1.6-5.8-2.5-10-2.5v17c4.2 0 7.8.9 10 2.5zm2 0c2.2-1.6 5.8-2.5 10-2.5v17c-4.2 0-7.8.9-10 2.5z"/>
  </svg>
)

export default Book
